module.exports = __webpack_public_path__ + "img/horizontal_4_3_7005.845f2eca.png";